import { useId } from 'react'
import { mascotPoses, type IllustratedPose } from './rogerio/mascotPoses'
import './rogerio-mascot.css'

function PoseLayers({ pose, id }: { pose: IllustratedPose; id: string }) {
  const parts = mascotPoses[pose]
  const source = `/assets/rogerio/rogerio-${pose}.webp`
  const gesture = <g className={`rogerio-mascot__part rogerio-mascot__part--${parts.gestureName}`}><image href={source} width="512" height="768" clipPath={`url(#${id}-gesture)`} /></g>
  return <>
    <defs>
      <clipPath id={`${id}-head`}><path d={parts.head} /></clipPath>
      <clipPath id={`${id}-gesture`}><path d={parts.gesture} /></clipPath>
      <mask id={`${id}-rest`} maskUnits="userSpaceOnUse" x="0" y="0" width="512" height="768">
        <rect width="512" height="768" fill="white" />
        <path d={parts.head} fill="black" stroke="white" strokeWidth="16" />
        <path d={parts.gesture} fill="black" stroke="white" strokeWidth="14" />
      </mask>
    </defs>
    <g className="rogerio-mascot__pose-body">
      {'behind' in parts && parts.behind && gesture}
      <image href={source} width="512" height="768" mask={`url(#${id}-rest)`} />
      <g className="rogerio-mascot__part rogerio-mascot__part--head"><image href={source} width="512" height="768" clipPath={`url(#${id}-head)`} /></g>
      {!('behind' in parts) && gesture}
    </g>
  </>
}

/** Contour masks isolate the illustrated parts; all motion stays in SVG/CSS. */
export default function RogerioMascot({ pose = 'curioso', decorative = false }: { pose?: string; decorative?: boolean }) {
  const id = useId().replaceAll(':', '')
  const atlas = '/assets/rogerio/rogerio-partes.webp'
  if (Object.hasOwn(mascotPoses, pose)) return <svg className="rogerio-mascot" data-pose={pose} viewBox="0 0 512 790" role={decorative ? undefined : 'img'} aria-label={decorative ? undefined : `Rogério ${pose}, o gato da Oficina IA`} aria-hidden={decorative || undefined}>
    <PoseLayers pose={pose as IllustratedPose} id={id} />
  </svg>
  return <svg className="rogerio-mascot" data-pose={pose} viewBox="0 0 512 790" role={decorative ? undefined : 'img'} aria-label={decorative ? undefined : `Rogério ${pose}, o gato da Oficina IA`} aria-hidden={decorative || undefined}>
    <defs>
      <clipPath id={`${id}-body`}><path d="M202 196 Q220 235 268 246 Q350 252 411 234 Q440 282 439 357 L446 447 Q460 522 495 580 Q529 628 534 686 Q533 746 484 782 Q470 860 424 860 Q389 860 369 833 L352 857 Q350 925 303 928 Q247 930 242 897 L232 818 Q180 856 129 849 Q95 845 101 812 Q100 788 120 773 Q88 725 90 664 Q90 606 123 551 Q145 491 149 427 L157 302 Q166 242 202 196Z" /></clipPath>
      <clipPath id={`${id}-head`}><path d="M0 0H512V297H362Q275 328 185 276H0Z" /></clipPath>
      <clipPath id={`${id}-tail`}><path d="M280 1078 Q321 1037 362 1053 Q420 1070 450 1142 Q484 1215 471 1290 Q466 1370 411 1420 Q352 1463 272 1490 Q263 1450 281 1404 Q300 1370 333 1337 Q368 1298 359 1238 Q355 1196 325 1167 Q278 1131 274 1103Z" /></clipPath>
      <clipPath id={`${id}-paw`}><path d="M608 1200 Q628 1155 672 1147 Q719 1142 745 1182 Q765 1212 769 1246 Q803 1291 786 1346 Q769 1390 730 1396 Q690 1398 657 1370 Q627 1347 613 1305 Q589 1255 608 1200Z" /></clipPath>
    </defs>
    <g className="rogerio-mascot__breath">
      <g className="rogerio-mascot__tail"><svg x="347" y="413" width="136" height="276" viewBox="240 1030 255 480"><image href={atlas} width="1024" height="1536" clipPath={`url(#${id}-tail)`} /></svg></g>
      <svg x="82" y="256" width="324" height="510" viewBox="60 165 505 785"><image href={atlas} width="1024" height="1536" clipPath={`url(#${id}-body)`} /></svg>
      <g className="rogerio-mascot__paw"><svg x="92" y="386" width="132" height="162" viewBox="570 1125 240 295"><image href={atlas} width="1024" height="1536" clipPath={`url(#${id}-paw)`} /></svg></g>
      <g transform="translate(0 24)"><g className="rogerio-mascot__head"><image href="/assets/rogerio/rogerio-curioso.webp" width="512" height="768" clipPath={`url(#${id}-head)`} /></g></g>
    </g>
  </svg>
}
